export const cdnAsset = function (path) {
  return process.env.MIX_CDN_URL
    ? process.env.MIX_CDN_URL + '/' + path.replace(/^\/+/g, '')
    : path;
};
